var map = {
	".": [
		22974,
		9
	],
	"./": [
		22974,
		9
	],
	"./App": [
		17391,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.test": [
		20477,
		9,
		2012,
		6004,
		9054
	],
	"./App.test.tsx": [
		20477,
		9,
		2012,
		6004,
		9054
	],
	"./App.tsx": [
		17391,
		9
	],
	"./BottomTree": [
		66149,
		9
	],
	"./BottomTree.tsx": [
		66149,
		9
	],
	"./Const": [
		6709,
		9
	],
	"./Const.ts": [
		6709,
		9
	],
	"./ContextMenu": [
		82518,
		9
	],
	"./ContextMenu.tsx": [
		82518,
		9
	],
	"./DateExtensions": [
		33782,
		9
	],
	"./DateExtensions.ts": [
		33782,
		9
	],
	"./DateTimeHelper": [
		15905,
		9
	],
	"./DateTimeHelper.ts": [
		15905,
		9
	],
	"./Errors/Unauthorized": [
		92776,
		9
	],
	"./Errors/Unauthorized.ts": [
		92776,
		9
	],
	"./InputBox": [
		83311,
		9
	],
	"./InputBox.tsx": [
		83311,
		9
	],
	"./InputYearDropdown": [
		63930,
		9
	],
	"./InputYearDropdown.tsx": [
		63930,
		9
	],
	"./LastMatches": [
		37433,
		9
	],
	"./LastMatches.css": [
		99912,
		9
	],
	"./LastMatches.tsx": [
		37433,
		9
	],
	"./LastYearsWinners": [
		71558,
		9
	],
	"./LastYearsWinners.css": [
		9477,
		9
	],
	"./LastYearsWinners.tsx": [
		71558,
		9
	],
	"./OrganizationYearWeekPage": [
		98800,
		9
	],
	"./OrganizationYearWeekPage.tsx": [
		98800,
		9
	],
	"./OrganizationYearWeekPageSwitcher": [
		20866,
		9
	],
	"./OrganizationYearWeekPageSwitcher.tsx": [
		20866,
		9
	],
	"./Pages.css": [
		52759,
		9
	],
	"./Services/ServiceEditor": [
		47459,
		9
	],
	"./Services/ServiceEditor.tsx": [
		47459,
		9
	],
	"./Services/ServicePlayer": [
		8699,
		9
	],
	"./Services/ServicePlayer.tsx": [
		8699,
		9
	],
	"./Services/ServiceSecurity": [
		90849,
		9
	],
	"./Services/ServiceSecurity.tsx": [
		90849,
		9
	],
	"./Services/ServiceTypes": [
		40403,
		9
	],
	"./Services/ServiceTypes.ts": [
		40403,
		9
	],
	"./SignalRContext": [
		60467,
		9
	],
	"./SignalRContext.tsx": [
		60467,
		9
	],
	"./SignalRService": [
		17559,
		9
	],
	"./SignalRService.ts": [
		17559,
		9
	],
	"./SupportForm": [
		67837,
		9
	],
	"./SupportForm.css": [
		83520,
		9
	],
	"./SupportForm.tsx": [
		67837,
		9
	],
	"./TopPlayerForLastYear": [
		63372,
		9
	],
	"./TopPlayerForLastYear.css": [
		10355,
		9
	],
	"./TopPlayerForLastYear.tsx": [
		63372,
		9
	],
	"./TopPlayerForPeriod": [
		69764,
		9
	],
	"./TopPlayerForPeriod.css": [
		89871,
		9
	],
	"./TopPlayerForPeriod.tsx": [
		69764,
		9
	],
	"./TopPlayerForPeriodAnim": [
		99379,
		9,
		9379
	],
	"./TopPlayerForPeriodAnim.tsx": [
		99379,
		9,
		9379
	],
	"./TopPlayersForLastYear": [
		74603,
		9
	],
	"./TopPlayersForLastYear.tsx": [
		74603,
		9
	],
	"./TopPlayersForPeriod": [
		90879,
		9
	],
	"./TopPlayersForPeriod.css": [
		52646,
		9,
		2646
	],
	"./TopPlayersForPeriod.tsx": [
		90879,
		9
	],
	"./TopPlayersForPeriodAnim": [
		92144,
		9,
		2144
	],
	"./TopPlayersForPeriodAnim.tsx": [
		92144,
		9,
		2144
	],
	"./UgeDagPage": [
		62430,
		9
	],
	"./UgeDagPage.css": [
		8753,
		9
	],
	"./UgeDagPage.tsx": [
		62430,
		9
	],
	"./Util": [
		50198,
		9
	],
	"./Util.ts": [
		50198,
		9
	],
	"./VSOSudoku": [
		2745,
		9
	],
	"./VSOSudoku.tsx": [
		2745,
		9
	],
	"./VSOTable": [
		33052,
		9
	],
	"./VSOTable.tsx": [
		33052,
		9
	],
	"./WooNotes/AutofillCloneFix": [
		56067,
		9,
		6067
	],
	"./WooNotes/AutofillCloneFix.tsx": [
		56067,
		9,
		6067
	],
	"./WooNotes/LoaderOverlay": [
		78998,
		9
	],
	"./WooNotes/LoaderOverlay.css": [
		51077,
		9
	],
	"./WooNotes/LoaderOverlay.tsx": [
		78998,
		9
	],
	"./WooNotes/WooBadge": [
		71795,
		9,
		1795
	],
	"./WooNotes/WooBadge.tsx": [
		71795,
		9,
		1795
	],
	"./WooNotes/WooEditorAndNodes": [
		26653,
		9
	],
	"./WooNotes/WooEditorAndNodes.css": [
		37730,
		9
	],
	"./WooNotes/WooEditorAndNodes.tsx": [
		26653,
		9
	],
	"./WooNotes/WooEditorHelper": [
		24809,
		9
	],
	"./WooNotes/WooEditorHelper.ts": [
		24809,
		9
	],
	"./WooNotes/WooLogin": [
		87129,
		9
	],
	"./WooNotes/WooLogin.css": [
		74004,
		9
	],
	"./WooNotes/WooLogin.tsx": [
		87129,
		9
	],
	"./WooNotes/WooNotes": [
		62593,
		9
	],
	"./WooNotes/WooNotes.css": [
		18276,
		9
	],
	"./WooNotes/WooNotes.tsx": [
		62593,
		9
	],
	"./WooNotes/WooNotesButton": [
		88153,
		9
	],
	"./WooNotes/WooNotesButton.tsx": [
		88153,
		9
	],
	"./WooNotes/WooNotesCheckbox": [
		90706,
		9,
		706
	],
	"./WooNotes/WooNotesCheckbox.tsx": [
		90706,
		9,
		706
	],
	"./WooNotes/WooNotesControlsCommon": [
		20508,
		9
	],
	"./WooNotes/WooNotesControlsCommon.tsx": [
		20508,
		9
	],
	"./WooNotes/WooNotesErrorAlert": [
		75329,
		9
	],
	"./WooNotes/WooNotesErrorAlert.tsx": [
		75329,
		9
	],
	"./WooNotes/WooNotesInfoAlert": [
		23403,
		9
	],
	"./WooNotes/WooNotesInfoAlert.tsx": [
		23403,
		9
	],
	"./WooNotes/WooNotesPasswordInput": [
		35132,
		9
	],
	"./WooNotes/WooNotesPasswordInput.tsx": [
		35132,
		9
	],
	"./WooNotes/WooNotesPopupMenu": [
		16390,
		9
	],
	"./WooNotes/WooNotesPopupMenu.tsx": [
		16390,
		9
	],
	"./WooNotes/WooNotesRadio": [
		1032,
		9,
		1032
	],
	"./WooNotes/WooNotesRadio.tsx": [
		1032,
		9,
		1032
	],
	"./WooNotes/WooNotesSettings": [
		57098,
		9,
		7098
	],
	"./WooNotes/WooNotesSettings.tsx": [
		57098,
		9,
		7098
	],
	"./WooNotes/WooNotesTextInput": [
		78722,
		9
	],
	"./WooNotes/WooNotesTextInput.tsx": [
		78722,
		9
	],
	"./WooNotes/WooStyles": [
		41818,
		9,
		1818
	],
	"./WooNotes/WooStyles.tsx": [
		41818,
		9,
		1818
	],
	"./WooNotes/WooTreeNode": [
		4388,
		9,
		4388
	],
	"./WooNotes/WooTreeNode.tsx": [
		4388,
		9,
		4388
	],
	"./WooNotes/WooTypeBadge": [
		69147,
		9,
		9147
	],
	"./WooNotes/WooTypeBadge.tsx": [
		69147,
		9,
		9147
	],
	"./WooNotes/filterFoldersWithoutText": [
		23201,
		9,
		3201
	],
	"./WooNotes/filterFoldersWithoutText.ts": [
		23201,
		9,
		3201
	],
	"./WooNotes/folders": [
		63865,
		9
	],
	"./WooNotes/folders.css": [
		42389,
		9
	],
	"./WooNotes/folders.tsx": [
		63865,
		9
	],
	"./WooNotes/getCaretIndexWithSeparators": [
		95878,
		9
	],
	"./WooNotes/getCaretIndexWithSeparators.tsx": [
		95878,
		9
	],
	"./WooNotes/mapEditorNodesToFolderNodes": [
		22801,
		9
	],
	"./WooNotes/mapEditorNodesToFolderNodes.ts": [
		22801,
		9
	],
	"./WooNotes/testsvg": [
		68651,
		9,
		8651
	],
	"./WooNotes/testsvg.tsx": [
		68651,
		9,
		8651
	],
	"./WooNotes/testsvg2": [
		17413,
		9,
		7413
	],
	"./WooNotes/testsvg2.tsx": [
		17413,
		9,
		7413
	],
	"./assets/background.png": [
		39528,
		1,
		9528
	],
	"./assets/christmasparty.png": [
		34408,
		1,
		4408
	],
	"./assets/christmasparty2.png": [
		29384,
		1,
		9384
	],
	"./assets/christmaspartyafter.jpg": [
		67400,
		1,
		7400
	],
	"./assets/christmaspartyloading10.jpg": [
		93909,
		1,
		3909
	],
	"./assets/christmaspartyloading25.jpg": [
		30301,
		1,
		301
	],
	"./assets/christmaspartyloading42.jpg": [
		85472,
		1,
		5472
	],
	"./assets/christmaspartyloading55.jpg": [
		83304,
		1,
		3304
	],
	"./assets/christmaspartyloading67.jpg": [
		63147,
		1,
		3147
	],
	"./assets/christmaspartyloading83.jpg": [
		41489,
		1,
		1489
	],
	"./assets/christmaspartyloading99dot9.jpg": [
		54006,
		1,
		4006
	],
	"./assets/home/button.pdn": [
		92490,
		1,
		2490
	],
	"./assets/home/dashboardbutton.png": [
		72228,
		1
	],
	"./assets/home/demobutton.png": [
		40635,
		1,
		635
	],
	"./assets/home/externaldashboard.png": [
		39971,
		1
	],
	"./assets/home/externaldashboarddialog.png": [
		5715,
		1
	],
	"./assets/home/externaldashboardinbrowser.png": [
		54748,
		1
	],
	"./assets/home/feedback.png": [
		7047,
		1
	],
	"./assets/home/feedbackbutton.png": [
		56443,
		1
	],
	"./assets/home/feedbackdialog.png": [
		60807,
		1
	],
	"./assets/home/feedbackdialogsubmitted.png": [
		15656,
		1
	],
	"./assets/home/husholdgotoserpapi.png": [
		33978,
		1
	],
	"./assets/home/husholdlogolarge2.png": [
		19103,
		1
	],
	"./assets/home/husholdremovealldata.png": [
		59766,
		1
	],
	"./assets/home/husholdremovealldataconfirm.png": [
		85072,
		1
	],
	"./assets/home/husholdtitle.png": [
		93021,
		1
	],
	"./assets/home/husholdtitle2.png": [
		89563,
		1,
		9563
	],
	"./assets/home/itimertoo307.png": [
		94988,
		1,
		4988
	],
	"./assets/home/itimertootitle.png": [
		54810,
		1,
		4810
	],
	"./assets/home/privacy1.png": [
		94451,
		1
	],
	"./assets/home/privacy2.png": [
		19960,
		1
	],
	"./assets/home/privacy3.png": [
		92673,
		1
	],
	"./assets/home/privacy4.png": [
		25934,
		1
	],
	"./assets/home/privacy5.png": [
		99575,
		1
	],
	"./assets/home/privacy6.png": [
		10844,
		1
	],
	"./assets/home/privacybutton.png": [
		31396,
		1
	],
	"./assets/home/rankytanktitle.png": [
		54813,
		1
	],
	"./assets/home/reportingbutton.png": [
		26734,
		1
	],
	"./assets/home/reportplayer.png": [
		54711,
		1
	],
	"./assets/home/reportplayerdialog.png": [
		17623,
		1
	],
	"./assets/home/reportplayerdialogsubmitted.png": [
		72440,
		1
	],
	"./assets/home/searchwithserpapi1.png": [
		24761,
		1
	],
	"./assets/home/searchwithserpapi2.png": [
		68674,
		1
	],
	"./assets/home/searchwithserpapi3.png": [
		89803,
		1
	],
	"./assets/home/sendbutton.png": [
		84364,
		1
	],
	"./assets/home/sendingbutton.png": [
		16998,
		1
	],
	"./assets/home/serpapibutton.png": [
		44314,
		1
	],
	"./assets/home/serpapiwww1.png": [
		22880,
		1
	],
	"./assets/home/serpapiwww2.png": [
		1211,
		1
	],
	"./assets/home/supportbutton.png": [
		51349,
		1
	],
	"./assets/home/tekstur1337.png": [
		57454,
		1
	],
	"./assets/home/tekstur1337old.png": [
		53067,
		1,
		3067
	],
	"./assets/home/tekstur307.png": [
		45378,
		1,
		5378
	],
	"./assets/home/teksturtitle.png": [
		44008,
		1
	],
	"./assets/home/teksturtitle2.png": [
		46600,
		1,
		6600
	],
	"./assets/home/workinprogress.png": [
		95233,
		1,
		5233
	],
	"./assets/home/workinprogress2.png": [
		35687,
		1,
		5687
	],
	"./assets/home/wwwappstore15pct.png": [
		81462,
		1
	],
	"./assets/home/wwwgoogleplay15pct.png": [
		94263,
		1
	],
	"./assets/home/wwwrankytank30pct.png": [
		79010,
		1
	],
	"./assets/home/wwwrankytanktitle.png": [
		13230,
		1
	],
	"./assets/home/wwwwoohooo.png": [
		75805,
		1
	],
	"./assets/kidschristmasparty.jpg": [
		97339,
		1,
		7339
	],
	"./assets/rankytank.png": [
		36201,
		1
	],
	"./assets/snow-flake-192x192.png": [
		51762,
		1,
		1762
	],
	"./assets/snow-flake2-192x192.png": [
		75936,
		1
	],
	"./assets/vsosudokulogo.png": [
		85024,
		1,
		5024
	],
	"./assets/vsosudokulogo2.png": [
		47728,
		1,
		7728
	],
	"./assets/vsosudokulogo3.png": [
		63481,
		1
	],
	"./assets/woohooo.gif": [
		66105,
		1
	],
	"./assets/xmas-bottomright.png": [
		63991,
		1,
		3991
	],
	"./assets/xmas-topleft.png": [
		22504,
		1,
		2504
	],
	"./assets/xmas.png": [
		99009,
		1,
		9009
	],
	"./bak.txt": [
		40564,
		1,
		564
	],
	"./dashboard": [
		48558,
		9
	],
	"./dashboard.css": [
		63835,
		9
	],
	"./dashboard.tsx": [
		48558,
		9
	],
	"./dialog/IsUnauthorizedDialog": [
		70015,
		9
	],
	"./dialog/IsUnauthorizedDialog.tsx": [
		70015,
		9
	],
	"./dialog/changePasswordDialog": [
		74402,
		9
	],
	"./dialog/changePasswordDialog.tsx": [
		74402,
		9
	],
	"./dialog/confirmMoveNodeDialog": [
		55398,
		9
	],
	"./dialog/confirmMoveNodeDialog.tsx": [
		55398,
		9
	],
	"./dialog/confirmRemoveAttachmentDialog": [
		97362,
		9
	],
	"./dialog/confirmRemoveAttachmentDialog.tsx": [
		97362,
		9
	],
	"./dialog/confirmRemoveFolderDialog": [
		41597,
		9
	],
	"./dialog/confirmRemoveFolderDialog.tsx": [
		41597,
		9
	],
	"./dialog/confirmSetFolderItemUnlockedDialog": [
		98347,
		9
	],
	"./dialog/confirmSetFolderItemUnlockedDialog.tsx": [
		98347,
		9
	],
	"./dialog/createFolderNodeDialog": [
		42889,
		9
	],
	"./dialog/createFolderNodeDialog.tsx": [
		42889,
		9
	],
	"./dialog/createItemNodeDialog": [
		12160,
		9
	],
	"./dialog/createItemNodeDialog.tsx": [
		12160,
		9
	],
	"./dialog/errorDialog": [
		47303,
		9
	],
	"./dialog/errorDialog.tsx": [
		47303,
		9
	],
	"./dialog/nameDialog": [
		65844,
		9,
		5844
	],
	"./dialog/nameDialog.css": [
		14097,
		9
	],
	"./dialog/nameDialog.tsx": [
		65844,
		9,
		5844
	],
	"./dialog/nodeAttachmentsDialog": [
		19507,
		9
	],
	"./dialog/nodeAttachmentsDialog.tsx": [
		19507,
		9
	],
	"./dialog/nodeHistoryDialog": [
		11989,
		9
	],
	"./dialog/nodeHistoryDialog.tsx": [
		11989,
		9
	],
	"./dialog/renameNodeDialog": [
		94387,
		9
	],
	"./dialog/renameNodeDialog.tsx": [
		94387,
		9
	],
	"./feedback": [
		40153,
		9
	],
	"./feedback.css": [
		57462,
		9
	],
	"./feedback.tsx": [
		40153,
		9
	],
	"./flexdiv": [
		73100,
		9
	],
	"./flexdiv.tsx": [
		73100,
		9
	],
	"./footer": [
		26921,
		9
	],
	"./footer.tsx": [
		26921,
		9
	],
	"./helpers/downloadFileHelper": [
		77524,
		9,
		7524
	],
	"./helpers/downloadFileHelper.tsx": [
		77524,
		9,
		7524
	],
	"./home": [
		1213,
		9
	],
	"./home.css": [
		24206,
		9
	],
	"./home.tsx": [
		1213,
		9
	],
	"./hooks/useBeforeUnload": [
		11018,
		9
	],
	"./hooks/useBeforeUnload.ts": [
		11018,
		9
	],
	"./hooks/useDelayedLoading": [
		47600,
		9
	],
	"./hooks/useDelayedLoading.ts": [
		47600,
		9
	],
	"./hooks/useDidMountEffect": [
		23227,
		9
	],
	"./hooks/useDidMountEffect.tsx": [
		23227,
		9
	],
	"./hooks/useEffectAfterMount": [
		67948,
		9
	],
	"./hooks/useEffectAfterMount.ts": [
		67948,
		9
	],
	"./hooks/useElementDimensions": [
		75463,
		9
	],
	"./hooks/useElementDimensions.tsx": [
		75463,
		9
	],
	"./hooks/useGlobalCtrlAndKeypress": [
		93039,
		9
	],
	"./hooks/useGlobalCtrlAndKeypress.tsx": [
		93039,
		9
	],
	"./hooks/useSyncedState": [
		78091,
		9
	],
	"./hooks/useSyncedState.ts": [
		78091,
		9
	],
	"./hooks/useSyncedStateWithDepChanges": [
		63981,
		9,
		3981
	],
	"./hooks/useSyncedStateWithDepChanges.ts": [
		63981,
		9,
		3981
	],
	"./hooks/useWindowDimensions": [
		2911,
		9
	],
	"./hooks/useWindowDimensions.ts": [
		2911,
		9
	],
	"./htmldiff": [
		36402,
		9,
		5388,
		6402
	],
	"./htmldiff.tsx": [
		36402,
		9,
		5388,
		6402
	],
	"./hushold": [
		83125,
		9
	],
	"./hushold.tsx": [
		83125,
		9
	],
	"./husholdsupport": [
		27948,
		9
	],
	"./husholdsupport.tsx": [
		27948,
		9
	],
	"./index": [
		22974,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.tsx": [
		22974,
		9
	],
	"./logo.svg": [
		69445,
		1,
		9445
	],
	"./privacy": [
		20642,
		9
	],
	"./privacy.css": [
		51703,
		9
	],
	"./privacy.tsx": [
		20642,
		9
	],
	"./privacyhushold": [
		88511,
		9
	],
	"./privacyhushold.css": [
		87668,
		9
	],
	"./privacyhushold.tsx": [
		88511,
		9
	],
	"./privacyserpapi": [
		68878,
		9
	],
	"./privacyserpapi.css": [
		44765,
		9
	],
	"./privacyserpapi.tsx": [
		68878,
		9
	],
	"./rankytank": [
		84137,
		9
	],
	"./rankytank.tsx": [
		84137,
		9
	],
	"./react-app-env.d": [
		55059,
		7,
		5059
	],
	"./react-app-env.d.ts": [
		55059,
		7,
		5059
	],
	"./reportWebVitals": [
		16469,
		9
	],
	"./reportWebVitals.ts": [
		16469,
		9
	],
	"./reporting": [
		33284,
		9
	],
	"./reporting.css": [
		68625,
		9
	],
	"./reporting.tsx": [
		33284,
		9
	],
	"./setupTests": [
		35374,
		9,
		2012,
		1405,
		5374
	],
	"./setupTests.ts": [
		35374,
		9,
		2012,
		1405,
		5374
	],
	"./splitview/SplitView": [
		27055,
		9
	],
	"./splitview/SplitView.css": [
		7394,
		9
	],
	"./splitview/SplitView.tsx": [
		27055,
		9
	],
	"./storage/lastOpenFolderNodesStore": [
		984,
		9
	],
	"./storage/lastOpenFolderNodesStore.ts": [
		984,
		9
	],
	"./storage/lastOpenItemNodeStore": [
		99012,
		9
	],
	"./storage/lastOpenItemNodeStore.ts": [
		99012,
		9
	],
	"./storage/lastSplitViewLeftWidthStore": [
		4625,
		9
	],
	"./storage/lastSplitViewLeftWidthStore.ts": [
		4625,
		9
	],
	"./storage/lastUsernameStore": [
		80533,
		9
	],
	"./storage/lastUsernameStore.ts": [
		80533,
		9
	],
	"./storage/tokenStore": [
		60096,
		9
	],
	"./storage/tokenStore.ts": [
		60096,
		9
	],
	"./support": [
		69619,
		9
	],
	"./support.tsx": [
		69619,
		9
	],
	"./tekstur": [
		96934,
		9
	],
	"./tekstur.tsx": [
		96934,
		9
	],
	"./teksturprivacy": [
		28628,
		9
	],
	"./teksturprivacy.tsx": [
		28628,
		9
	],
	"./tekstursupport": [
		80861,
		9
	],
	"./tekstursupport.tsx": [
		80861,
		9
	],
	"./types/diff-match-patch.d": [
		70212,
		7,
		212
	],
	"./types/diff-match-patch.d.ts": [
		70212,
		7,
		212
	],
	"./useCaseInsensitiveSearchParams": [
		51350,
		9
	],
	"./useCaseInsensitiveSearchParams.ts": [
		51350,
		9
	],
	"./useImagePreloader": [
		53028,
		9
	],
	"./useImagePreloader.ts": [
		53028,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28969;
module.exports = webpackAsyncContext;